module.exports = __webpack_public_path__ + "static/buttonBack-44e32e3e71ea2befa4844f24af29ef62.png";